export const english = {
  adminDashboard: {
    title: "Menu Catalog",
    headline: "select a template",
    deleteMenu: "Delete menu",
    deleteInfo: "Do you want remove menu: ",
    deleteBtn: "DELETE",
    cancelBtn: "CANCEL",
    menuDeletedSuccess: "Menu deletion was successful",
    menuDeletedError: "Menu deletion has failed",
    menuCopySuccess: "Menu copy was successful",
    menuCopyError: "Menu copying has failed",
    tabFood: "Food",
    tabLunch: "Lunch",
    tabAlcohol: "Alcohols",
    tabSoda: "Soda",
    tabChild: "Child'S menu",
    tabChristmas: "X-mas menu",
  },
  clientView: {
    loading: "Loading...",
    footerContent: "Powered by",
    footerLink: "GastronomiaQR.com",
    tabFood: "Food",
    tabLunch: "Lunch",
    tabAlcohol: "Alcohols",
    tabSoda: "Soda",
    tabChild: "Child'S menu",
    tabChristmas: "X-mas menu",
    tabAllergens: "Allergens",
    location: "Location",
    openHours: "Open hours",
    weekDays: "Week's days",
    middayHours: "Midday hours",
    eveningNightHours: "Evening / night hours",
    contact: "Contact",
    followUs: "Follow us:",
    logoTitle: "GastronomiaQR",
    logoRestaurant: "Restaurant logo",
    expired:
      "We're sorry, the restaurant {{name}} does not have the service active yet. Ask them to activate it now!",
    nonExist: "We're sorry, the restaurant you are looking for does not exist",
  },
  allergens: {
    names: {
      eggs: "Eggs",
      lactose: "Lactose",
      fish: "Fish",
      sea: "Sea",
      shellfish: "Shellfish",
      nuts: "Nuts",
      soy: "Soy",
      gluten: "Gluten free",
      sesame: "Sesame",
      mustard: "Mustard",
      celery: "Celery",
      sulfur: "Sulfur",
    },
    descriptions: {
      eggs: "Eggsz",
      lactose: "Lactose",
      fish: "Fish",
      sea: "Sea",
      shellfish: "Shellfish",
      nuts: "Nuts",
      soy: "Soy",
      gluten: "Gluten free",
      sesame: "Sesame",
      mustard: "Mustard",
      celery: "Celery",
      sulfur: "Sulfur",
    },
  },
  terms: {
    backBtn: "BACK",
    content:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore.",
    title: "Terms",
  },
  navigation: {
    logoTitle: "GastronomiaQR",
    faq: "FAQ",
    about: "About",
    support: "Support",
    buttonReservation: "RESERVATIONS",
    buttonComingSoon: "COMING SOON",
    freeFor: "100% Free for",
    expired: "Your trial version has expired",
    days: "days",
    terms: "Terms",
    logout: "Log out",
    editProfile: "Edit profile",
    qrCodes: "QR codes",
    completePayment: "Complete payment",
    logoutDialogTitle: "Logout",
    logoutDialogContent: "Are you sure you want to log out of the application ?",
    logoutCancelBtn: "CANCEL",
    logoutLogoutBtn: "LOGOUT",
    paymentAgreement: "Payment agreement",
    trialExpired:
      "Your trial period expired. You can continue using the platform, but your customer will not be able to see your menus. You can reactivate the service at any time, by simply going over the payment agreement.",
  },
  previewCard: {
    activeSwitch: "Activated",
    addMenu: "Add menu",
  },
  editTemplate: {
    returnBtn: "Back",
    title: "Change Design",
    headline: "SELECT A TEMPLATE",
    errors: {
      invalidFields: "Please check the highlighted fields",
    },
    dialog: {
      backBtn: {
        title: "Back to admin page",
        content: "You have not saved changes, are you sure?",
        backToAdmin: "BACK",
        stay: "STAY",
      },
    },
    hints: {
      copySection: "Copy this section",
      deleteSection: "Remove this section",
      addSection: "Add new section below",
      addLine: "Add new line",
      deleteLastLine: "Remove last line",
      copyEntry: "Copy this entry",
      deleteEntry: "Remove this entry",
      addEntry: "Add new entry below",
    },
    editMenu: {
      save: "Save",
      addSection: "Add section",
      addDish: "Add dish",
      promo: "Featured promo",
      color: "Theme Colors",
      restoreTheme: "Restore theme",
      undo: "Undo",
      redo: "Redo",
      preview: "Preview",
      clearMenu: "Clear menu",
    },
    inputPlaceholders: {
      sectionDescription: "Item description",
      description: "description",
      footer: "footer",
      title: "Title",
      sectionName: "Section name",
      specialEntry: "Special entry value",
    },
    themeEditor: {
      themeTitle: "Theme",
      heading: "Heading",
      description: "Description",
      price: "Price",
      dishTitle: "Selected Dish",
      priceType: "Price type",
      single: "Single",
      double: "Double",
      triple: "Triple",
      note: "Note",
      none: "None",
      spice: "Spice",
      allergens: "Allergens",
      allergensColor: "Allergens icon color",
      select: "Select...",
      type: "Type...",
      nonDecimal: "Coma point",
      decimal: "Decimal point",
    },
  },
  authentication: {
    signature: {
      title: "Cooperation principles",
      formInfo: "Complete bank account number and sign the above agreement",
      inputLabel: "Bank account number",
      skip: "SKIP",
      back: "BACK",
      signBtn: "Sign agreement",
      signature: "Signature",
      bankAccount: "Bank account",
      clickToDraw: "Click to draw",
      clearField: "Clear field",
      save: "Save",
      send: "Send",
      logout: "Logout",
      usageDescription: "Use mouse or tablet for signature",
      creditorName: "Creditor Name",
      creditorNameContent: "Mindful Software SL",
      creditorIdentifier: "Creditor identifier",
      creditorIdentifierContent: "346456457",
      creditorAddress: "Creditor Address (Street name and number)",
      creditorAddressContent: "Calle Henri Dunant 17",
      postalCodeCity: "Postal code/city",
      postalCodeCityContent: "28036 Madrid",
      country: "Country",
      countryContent: "Spain",
      mandateReference: "Mandate reference",
      mandateReferenceContent: "436475678",
      debtor: "Debtor",
      debtorContent:
        "By signing this mandate form, you authorise the creditor to send instructions to your bank to debit your account and your bank to debit your account in accordance with the creditor’s instructions. As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited.",
      confirmField: "Please complete all the fields marked *",
      nameOfDebtor: "Name of the debtor(s) (Person/Company)",
      debtorAddress: "Address (Street name and number)",
      debtorPostalCode: "Postal code/City",
      accountNumberIban: "Account number - IBAN",
      swiftBic: "SWIFT BIC",
      typeOfPayment: "Type of payment",
      locationDate: "Location/Date of Signature",
      recurrentPayment: "Recurrent payment",
      dateSign: "Madrid",
      signaturePlaceholder: "Please sign agreement below",
      forInfoPurposes: "For information purposes only",
      forInfoPurposesTooltip:
        "Debtor indicator code. If you are making a payment in respect of an arrangement between creditor and another person. Identification number of the underlying contract, maximum amount...",
      returnSepaCore:
        "Upon completion of this document, you will be able to find a signed copy in PDF format within your profile",
      sepaCoreNote:
        "Note: Your rights regarding the above mandate are explained in a statement that you can obtain from your bank.",
      or: "or",
      paymentAgreement: "Payment agreement",
      signUpDoneFree: "Sign Up done - free trial",
      signUpDoneFreeTitle: "Your trial period will be active for seven days",
      signUpDoneFreeText: "Thank you for your trust.",
      signUpDoneSigned: "Sign Up done",
      signUpDoneSignedTitle: "Your registration is complete",
      signUpDoneSignedText: "Thank you for your trust.",
      continue: "Continue",
      paymentAgreementPrice:
        "Full access for only <br /><strong>99 EUR / Yearly or 9.90 EUR / Monthly</strong>",
      fullVersion:
        "You can provide all the data and <strong>enjoy the application without limits and whithout worrying</strong> that your menu will disappear for Your customers",
      trialVersion:
        "You can skip this step and use the 7 day trial version. After that time, you will have access to your account, but your menu will not be displayed to users",
    },
    signUp: {
      facebookAddress: "Facebook address",
      instagramAddress: "Instagram address",
      twitterAddress: "Twitter address",
      correctFormatPhoto: "Correct format: jpg, png",
      maxWeightPhoto: "Max weight: 1 MB",
      companyData: "Company's Data",
      title: "Register your company and start creating your menu cards",
      hr: "hr",
      tradeName: "Tradename",
      localAddress: "Local Address",
      postalCode: "Postal code",
      city: "City",
      businessNumber: "Business number",
      phone: "Phone",
      administrativePhone: "Administrative contact",
      publicPhone: "Public phone",
      whatsApp: "WhatsApp",
      publicEmail: "Public email",
      openingTimes: "Opening hours",
      reserveRanges: "Reserve Ranges",
      midday: "Midday hours",
      nightEvening: "Evening/ night hours",
      monday: "MONDAY",
      tuesday: "TUESDAY",
      wednesday: "WEDNESDAY",
      thursday: "THURSDAY",
      friday: "FRIDAY",
      saturday: "SATURDAY",
      sunday: "SUNDAY",
      next: "Next",
      send: "Send",
      back: "BACK",
      addRange: "Add range",
      weeksDays: "Week's days",
      clearAll: "Clear all",
      emailAddress: "Email address",
      password: "Password (must be at least 8 characters long)",
      repeatPassword: "Repeat password",
      terms: "I accept the terms and conditions",
      edit: "Edit profile",
      titleRegisterFirstStep: "Register",
      descriptionRegisterFirstStep: "Join us in 2 simple steps",
      logout: "Logout",
      signUpDone: "Sign up done",
      welcomeMessageTitle: "Welcome to Mindful!",
      welcomeMessage:
        "Thank you for your trust and we hope that your website will not disappoint your expectations.",
      enjoyMessage: "Enjoy the Mindful !",
      login: "LOG IN",
    },
    signUpMobile: {
      welcome: "Welcome",
      pcEditorMessage:
        "From your computer you will have access to the editor, where you will be able to create and edit all your menus",
      waitForYou: "¡Te esperamos!",
    },
    errors: {
      isRequired: "Value is required",
      minLengthPass: "Password must contain at least 8 characters",
      wrongPass: "The password does not contain all the required characters",
      passNotMatch: "Passwords do not match",
      termNotChecked: "The condition must be checked",
      incorrectMail: "Incorrect email address",
      authErr: "Invalid login or password",
      emailNotExit: "Entered email doesn’t exist",
      invalidFacebook: "Invalid Facebook url",
      invalidTwitter: "Invalid Twitter url",
      invalidInstagram: "Invalid Instagram url",
      invalidBusinessNumber:
        "Business number should contain one letter at the beginning and 8 digits",
      invalidPhoneNumber: "Invalid phone number",
      invalidPostalCode: "Invalid postal code",
      wrongIban: "Invalid IBAN. Require Two charts at the beginning and 26 digits",
      wrongSwift: "Invalid SWIFT. Require 8-11 letters",
      apiError: "Something went wrong, try again",
    },
    signIn: {
      enter: "Enter",
      haveAcc: "Have not yet an account?",
      register: "Register",
      user: "User",
      password: "Password",
      login: "LOG IN",
      forgotPass: "Did you forget your password?",
      send: "Send",
      emailAddress: "Email address",
      back: "BACK",
      sentPassInfo:
        "We have sent a password reset link to the e-mail address provided. The link is valid 30 minutes.",
      remindPassInfo:
        "Enter your email address to which we will send a link to reset your password",
    },
    changePassword: {
      newPassword: "New password",
      RepeatNewPassword: "Repeat new password",
      save: "Save",
      componentTitle: "New login password",
      description: "Create a new password with at least 8 characters",
    },
  },
  errorPage: {
    content: "Something went wrong, please try again or visit us on:",
    buttonContent: "OUR WEBSITE",
  },
};
